import baseApi from './base';

const fetchBusinessConfig = () =>
  baseApi.request({
    method: 'get',
    url: '/business-rule'
  });

const modifySysConfig = data =>
  baseApi.request({
    method: 'patch',
    url: `/business-rule/${data.id}`,
    data
  });

export {
  fetchBusinessConfig,
  modifySysConfig
};


// WEBPACK FOOTER //
// ./src/api/businessConfig.js